import React from 'react';

import './style.css';

const DocumentLink = ({ position, title, url, urls }) => {
    return (
        <div key={position} className="document">
            {!urls && (
                <a href={url} target="window">
                    {title}
                </a>
            )}
            {urls && (
                <div className="document-urls">
                    <div>{title}</div>
                    <div className="document-urls-links">
                        {urls.map((u, idx) => (
                            <a key={`document-urls-link-${title}-${idx}`} href={u.url} target="window">
                                {u.title}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

const DocumentList = ({ documents, listTitle, sortFunc }) => {
    let sortedDocuments = documents ?? [];
    if (sortFunc) {
        sortedDocuments = sortedDocuments.sort((a, b) => sortFunc(a, b));
    }
    return (
        <div className="document-list">
            {sortedDocuments &&
                sortedDocuments?.map((doc, idx) => (
                    <DocumentLink
                        key={`${listTitle}-document-row-${idx}`}
                        title={doc.title}
                        url={doc.url}
                        urls={doc.urls}
                    />
                ))}
        </div>
    );
};

export { DocumentLink };
export default DocumentList;
